var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-input', {
    staticClass: "rule-title-input",
    attrs: {
      "placeholder": _vm.t('')
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };